<div fxLayout="column" fxLayoutAlign="center center">

  <div class="container">
    <div class="success-background slideInUp">
      <mat-icon>check</mat-icon>
    </div>

    <div class="title slideInUp">
      <span>THANK YOU</span>
    </div>

    <div class="sub-title slideInUp">
      <span>Form has been successfully submitted</span>
    </div>
  </div>
</div>
